export default __webpack_public_path__ + "static/media/element_48.d24635ec.jpg";